import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withKeys as _withKeys, withDirectives as _withDirectives, vModelText as _vModelText, vModelDynamic as _vModelDynamic, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fe9b2b14"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: -1,
  disabled: ""
}, "Seçiniz", -1))
const _hoisted_2 = ["value"]
const _hoisted_3 = ["type"]

import { ref, computed, nextTick } from "vue"

/*
Generic double-click-to-edit field. Supports text, number, date and select.
For select, pass `options` as [{ label, value }]; `value` may be a primitive or an
object (matched by `id`). Pass `display` to override the read-only text (e.g. for
values that don't map cleanly onto an option).
*/


export default /*#__PURE__*/_defineComponent({
  __name: 'editableField',
  props: {
    value: {},
    type: {},
    options: {},
    placeholder: {},
    label: {},
    display: {}
  },
  emits: ["update"],
  setup(__props: any, { emit: __emit }) {


const props = __props

const emit = __emit

const fieldType = computed(() => props.type || "text")
const isEditing = ref(false)
const draft = ref<any>(null)
const draftIndex = ref<number>(-1)
const inputEl = ref<any>(null)

const toDate = (value: any): Date | null => {
    if (!value) return null
    if (value?.toDate) return value.toDate()
    const date = new Date(value)
    return isNaN(date.getTime()) ? null : date
}

const toISODate = (value: any): string => {
    const date = toDate(value)
    return date ? date.toISOString().slice(0, 10) : ""
}

const matchIndex = (): number => {
    if (!props.options) return -1
    return props.options.findIndex((option) => {
        if (option.value && typeof option.value === "object" && props.value && typeof props.value === "object") {
            return option.value.id === props.value.id
        }
        return option.value === props.value
    })
}

const displayText = computed(() => {
    if (props.display) return props.display
    if (fieldType.value === "select") {
        const index = matchIndex()
        return index >= 0 ? props.options![index].label : (props.placeholder || "-")
    }
    if (fieldType.value === "date") {
        const date = toDate(props.value)
        return date ? date.toLocaleDateString("tr-TR", { year: "numeric", month: "long", day: "numeric" }) : (props.placeholder || "-")
    }
    if (props.value === 0) return `0${props.label ? " " + props.label : ""}`
    return props.value ? `${props.value}${props.label ? " " + props.label : ""}` : (props.placeholder || "-")
})

const startEdit = async () => {
    if (fieldType.value === "select") {
        draftIndex.value = matchIndex()
    } else if (fieldType.value === "date") {
        draft.value = toISODate(props.value)
    } else {
        draft.value = props.value ?? ""
    }
    isEditing.value = true
    await nextTick()
    inputEl.value?.focus?.()
    inputEl.value?.select?.()
}

const commit = () => {
    if (!isEditing.value) return
    isEditing.value = false
    if (fieldType.value === "select") {
        if (draftIndex.value >= 0) emit("update", props.options![draftIndex.value].value)
    } else if (fieldType.value === "date") {
        if (draft.value) emit("update", new Date(draft.value))
    } else if (fieldType.value === "number") {
        const num = Number(draft.value)
        if (!isNaN(num) && num !== props.value) emit("update", num)
    } else {
        const text = (draft.value ?? "").toString().trim()
        if (text !== (props.value ?? "")) emit("update", text)
    }
}

const cancel = () => {
    isEditing.value = false
}


return (_ctx: any,_cache: any) => {
  return (!isEditing.value)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass(["editable-field", { 'editable-field--empty': !_ctx.value && _ctx.value !== 0 && !_ctx.display }]),
        title: "Düzenlemek için çift tıklayın",
        onDblclick: startEdit
      }, _toDisplayString(displayText.value), 35))
    : (fieldType.value === 'select')
      ? _withDirectives((_openBlock(), _createElementBlock("select", {
          key: 1,
          ref_key: "inputEl",
          ref: inputEl,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((draftIndex).value = $event)),
          class: "editable-input",
          onChange: commit,
          onBlur: commit,
          onKeyup: _withKeys(cancel, ["esc"])
        }, [
          _hoisted_1,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (opt, i) => {
            return (_openBlock(), _createElementBlock("option", {
              key: i,
              value: i
            }, _toDisplayString(opt.label), 9, _hoisted_2))
          }), 128))
        ], 544)), [
          [_vModelSelect, draftIndex.value]
        ])
      : (fieldType.value === 'date')
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 2,
            ref_key: "inputEl",
            ref: inputEl,
            type: "date",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((draft).value = $event)),
            class: "editable-input",
            onBlur: commit,
            onKeyup: [
              _withKeys(commit, ["enter"]),
              _withKeys(cancel, ["esc"])
            ]
          }, null, 544)), [
            [_vModelText, draft.value]
          ])
        : _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 3,
            ref_key: "inputEl",
            ref: inputEl,
            type: fieldType.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((draft).value = $event)),
            class: "editable-input",
            onBlur: commit,
            onKeyup: [
              _withKeys(commit, ["enter"]),
              _withKeys(cancel, ["esc"])
            ]
          }, null, 40, _hoisted_3)), [
            [_vModelDynamic, draft.value]
          ])
}
}

})